import {useEffect} from "react";
import isEmpty from "is-empty";
import {isMobile} from "@/Helpers/Function";

export default function useShowContinueApplication(props) {
    const {mobileApp = false, stores = {}, continueApplication = {}} = props;
    const {modalStore = {}} = stores;

    useEffect(() => {
        const application = sessionStorage.getItem('continueApplication');
        if (!isEmpty(continueApplication) && !mobileApp && isMobile() && application === null) {
            modalStore.openApplicationDrawer();
        }
    }, []);
}
